import { render } from "./CalendarWeek.vue?vue&type=template&id=31e0514e&scoped=true&ts=true"
import script from "./CalendarWeek.vue?vue&type=script&lang=ts"
export * from "./CalendarWeek.vue?vue&type=script&lang=ts"

import "./CalendarWeek.vue?vue&type=style&index=0&id=31e0514e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e0514e"]])

export default __exports__